import React from 'react'
import { ScopeProductsSectionProps } from './ScopeProductsSection.types'
import styles from './ScopeProductsSection.module.scss'
import cl from 'classnames'
import { ImageSquare, Input, Text1 } from 'components/shared'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { AGREEMENT_PAGE_STORE } from 'store'
import { getMainImageSrcForObj } from 'utilities'
import { useProductsContainerHeight, useSearchFilter } from './ScopeProductsSection.utils'

const ScopeProductsSectionComponent = (props: ScopeProductsSectionProps) => {
  const {
    className,
    style,
    [AGREEMENT_PAGE_STORE]: {
      scopeProducts,
      scopeProductsCount,
      getChangeByKeyId
    }
  } = props

  const productsContainerHeight = useProductsContainerHeight(scopeProductsCount)
  const {
    searchValue,
    setSearchValue,
    filteredProducts
  } = useSearchFilter(scopeProducts)

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >
      <Text1 bold>
        Products ({scopeProductsCount})
      </Text1>
      <Input
        containerProps={{ className: styles.searchInput }}
        placeholder='Search...'
        value={searchValue}
        onChange={setSearchValue}
      />

      <div
        className={cl(styles.productsContainer, styles.scrollable)}
        style={{
          height: productsContainerHeight,
          maxHeight: productsContainerHeight,
          minHeight: productsContainerHeight
        }}
      >
        {filteredProducts.map(product => {
          const productChange = getChangeByKeyId(`product-${product.id}`)
          return (
            <div
              key={product.id}
              className={cl(styles.productView, {
                [styles.redBorder]: productChange
              })}
            >
              <ImageSquare
                src={getMainImageSrcForObj(product)}
                showBorder
                width={35}
              />
              <Text1
                overflowEllipsis
                style={{ marginLeft: 20 }}
                versionChangeAsLabel={productChange}
                // versionChange={productChange}
              >
                {product.name}
              </Text1>
            </div>
          )
        })}
      </div>
    </div>
  )
}

const ScopeProductsSection = inject(
  AGREEMENT_PAGE_STORE
)(observer(ScopeProductsSectionComponent))
export { ScopeProductsSection }
